var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"cliContainer",staticClass:"container-fluid h-100 overflow-auto",attrs:{"id":"cli_container"}},[_c('terminal-screen',{on:{"needScroll":_vm.scrollToEnd}}),_c('div',{staticClass:"h-25"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }